import { ReactElement, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Calendar, Col, Row, Button, Checkbox } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { Paper } from "@material-ui/core";
import { SET_BOOKING_DATE } from "../../redux/constants";
import { getBookingState, getAuthState } from "../../redux/selectors";

const femaleOnlyDays = [
  "Every Sunday",
  "Every Monday",
  "Every Tuesday",
  "Every Wednesday",
  "Every Thursday",
  "Every Friday",
  "Every Saturday"
]

export function BookingCalendar(): ReactElement {
  const dispatch = useDispatch();
  const { branchId } = useParams<{ branchId: string }>();
  const history = useHistory();
  const { t } = useTranslation();
  const { preBranch } = useSelector(getBookingState);
  const { currentUser } = useSelector(getAuthState);
  const [selectedDate, setSelectedDate] = useState<any>(moment());
  const [showNextMonth, setShowNextMonth] = useState<boolean>(false);
  const [showPrevMonth, setShowPrevMonth] = useState<boolean>(false);
  const [panelChanged, setPanelChanged] = useState<boolean>(false);
  const [isFemaleOnly, setFemaleOnly] = useState<boolean>(false);

  const clubData = preBranch?.clubData;

  const disableDate = (currentDate: any) => {
    const daysRanges = clubData?.bookingDatesRange;
    // const nowMonth = moment().month();
    // const currentMonth = currentDate.month();
    // const nowDate = moment().date();
    // if (nowDate < 20) {
    //   if (nowMonth !== currentMonth) return true;
    // } else if (nowMonth + 1 < currentMonth) {
    //   return true;
    // }

    if (currentUser?.role === "manager" || currentUser?.role === "admin") {
      return currentDate < moment().subtract(1, "d");
    }

    const endOfBookingDates = moment().add(daysRanges, "d");

    if (currentDate > endOfBookingDates) return true;

    if (isFemaleOnly) {
      const femaleOnly = preBranch ? preBranch.femaleOnly : [];
      const filtered = femaleOnly.filter((f: any) => f.day === currentDate.day().toString());
      if (filtered.length) return currentDate < moment().subtract(1, "d");
      return true;
    }
    return currentDate < moment().subtract(1, "d");
  };

  const onSelectDate = (selected: any) => {
    const date = selected.format("YYYY-MM-DD");
    dispatch({
      type: SET_BOOKING_DATE,
      payload: { date },
    });
    if (currentUser) {
      if (panelChanged) setPanelChanged(false);
      else history.push(`/booking/${branchId}/book`);
    } else {
      history.push(`/share/${preBranch?.clubData.firestoreRef}/${branchId}/booking`);
    }
  };

  const dateCellRender = (value: any) => {
    const day: number = value.day();
    const date: number = value.date();
    const femaleOnly = preBranch ? preBranch.femaleOnly : [];
    const filtered = femaleOnly.filter((f: any) => f.day === day.toString())
    if (filtered.length) {
      return (
        <div className="ant-picker-cell-inner ant-picker-calendar-date female-class-date">
          <div className="ant-picker-calendar-date-value">{date}</div>
          <div className="ant-picker-calendar-date-content">
            <div className="female-class">
              <div style={{ color: "#ffffff", fontSize: 12, fontWeight: 600 }}>Female Only</div>
              <div style={{ color: "#ffffff", fontSize: 12 }}>{filtered[0].startTime}~{filtered[0].endTime}</div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="ant-picker-cell-inner ant-picker-calendar-date">
        <div className="ant-picker-calendar-date-value">{date}</div>
        <div className="ant-picker-calendar-date-content" />
      </div>
    );
  };


  useEffect(() => {
    console.log(preBranch?.femaleOnly);
  }, [])

  // useEffect(() => {
  //   const today = moment();
  //   if(today.date() > 19){
  //     if(selectedDate.month() === today.month()){
  //       setShowNextMonth(true);
  //       setShowPrevMonth(false);
  //     } else {
  //       setShowPrevMonth(true);
  //       setShowNextMonth(false);
  //     }
  //   } else {
  //     setShowNextMonth(false);
  //     setShowPrevMonth(false);
  //   }
  // },[selectedDate]);

  // const onPressNextDate = () => {
  //   const nextDate = selectedDate.add(1, "M").date(moment().date());
  //   setSelectedDate(nextDate);
  // }
  // const onPressPrevDate = () => {
  //   const prevDate = selectedDate.subtract(1, "M").date(moment().date());
  //   setSelectedDate(prevDate);
  // }

  return (
    <Row style={{ justifyContent: "center", alignItems: "center", height: currentUser ? "" : "100vh" }}>
      <Col xs={24} sm={16}>
        <Paper style={{ padding: 20 }}>
          <h2 className="text-uppercase text-label" style={{ display: "flex", justifyContent: "space-between" }}>
            {t("booking.select_booking_date")}
            <span>
              <Checkbox onChange={(event) => setFemaleOnly(event.target.checked)}>Female Only</Checkbox>
            </span>
            <span style={{ float: "right" }}>
              {/* { showNextMonth && <Button type="primary" style={{ marginRight : 10}} onClick={onPressNextDate}>Next</Button> }
              { showPrevMonth && <Button type="primary" style={{ marginRight : 10}} onClick={onPressPrevDate}>Prev</Button> } */}
              {moment().format("MMM, YYYY")}
            </span>
          </h2>
          {preBranch?.femaleOnly.length > 0 && <Row gutter={16}>
            <Col xs={6} sm={4} md={2}>
              <span>Female hrs</span>
            </Col>
            <Col span={18}>
              <ul className="female_only_list">
                {preBranch?.femaleOnly.map(({ day, startTime, endTime }: any) => (
                  <li className="female_only_list_item">{`${femaleOnlyDays[parseInt(day, 10)]}, ${moment(startTime, "HH:mm").format("h:mm A")} ~ ${moment(endTime, "HH:mm").format("h:mm A")}`}</li>
                ))}
              </ul>
            </Col>
          </Row>}
          <div className={(currentUser?.role === "manager" || currentUser?.role === "admin") ? "" : "calendar-container-hide-header-action"}>
            <Calendar
              disabledDate={disableDate}
              onSelect={onSelectDate}
              // dateFullCellRender={dateCellRender}
              onPanelChange={() => setPanelChanged(true)}
            />
          </div>
        </Paper>
      </Col>
    </Row>
  );
}
